import axios from 'axios';
import { environment } from '@/data/environment/';


async function getCompanyToken(dispatch, idCompany) {
  const tokenInfo = JSON.parse(
    localStorage.getItem('tokenCompany') || 'null'
  );

  if (tokenInfo && Number(tokenInfo.idCompany) === Number(idCompany) && tokenInfo.token && tokenInfo.expiresAt > Date.now()) {
    return tokenInfo.token;
  }

  const token = await dispatch('fetchToken/getTokenByCompany', idCompany, { root: true });

  if (!token) {
    throw new Error('No fue posible obtener el token de la compañía');
  }

  localStorage.setItem('tokenCompany', JSON.stringify({idCompany: Number(idCompany), token, expiresAt: Date.now() + 30 * 60 * 1000,}));
  return token;
}

export default {
  namespaced: true,

  state: {
    paramConfigCode: [],
  },

  mutations: {
    paramConfigCode(state, data) {
      state.paramConfigCode = data;
    },
  },

  actions: {
    async getConfigParam({ commit, dispatch }, { idCompany, nameParam }) {
      const endpoint = `/api/companies/${idCompany}/paramCompany`;
      const url = environment.HIOPOSWEBSERVICES + endpoint;


      try {
        const token = await getCompanyToken(dispatch, idCompany);

        const response = await axios.post(
          url,
          {
            idCompany,
            nameParam,
          },
          {
            headers: {
              Authorization: `Bearer ${token} `,
              Accept: 'application/json',
            },
          }
        );

        commit('paramConfigCode', response.data);

        return response.data;
      } catch (error) {
        console.error('Error al consultar el parámetro:', error.response?.data || error.message);
        return null;
      }
    },

    async updateConfiguration({ commit, dispatch }, { idCompany, value, nameParam, codeParam }) {

      const endpoint = `/api/companies/${idCompany}/paramCompany/${codeParam} `;
      const url = environment.HIOPOSWEBSERVICES + endpoint;

      try {
        const token = await getCompanyToken(dispatch, idCompany);

        const response = await axios.post(
          url,
          {
            idCompany,
            value,
            nameParam,
          },
          {
            headers: {
              Authorization: `Bearer ${token} `,
              Accept: 'application/json',
            },
          }
        );

        commit('paramConfigCode', response.data.value);

        return response;
      } catch (error) {
        console.error(
          'Error al actualizar el parámetro:',
          error.response?.data || error.message
        );

        throw error;
      }
    },

  },
};
